const initialState = {
	vehicleSelected: {}	
};

const vehicleSelectedReducer = (state = initialState, action) => {
	if (action.type === "vehicleSelected") {
		return { ...state, vehicleSelected: action.value };
	}

	return state;
};

export default vehicleSelectedReducer;
